import React from "react";
import ManagementExpo from "./managementExpo";
import ManagementValueExpo from "./managementValueExpo";
import InspectionExpo from "./inspectionExpo";
import RefrigerationExpo from "./refrigarationExpo";
import CongelationExpo from "./congelationExpo";
import DangerousGoods from "./dangerousGoods";
import DryIceExpo from "./dryIce";
import LiveAnimalsExpo from "./liveAnimals";
import InvoiceCancellationExpo from "./invoiceCancellation";
import StrappingAndPackaging from "./strappingAndPackaging";

const vistasExpo = {
  management: ManagementExpo,
  value_management: ManagementValueExpo,
  inspection: InspectionExpo,
  refrigeration: RefrigerationExpo,
  congelation: CongelationExpo,
  dangerous_goods: DangerousGoods,
  dry_ice: DryIceExpo,
  live_animals: LiveAnimalsExpo,
  cancelation_factura: InvoiceCancellationExpo,
  strapping_packaging: StrappingAndPackaging,
};

function VistaDetalleExpo({ concepto, onClose, tarifas, actualizarTarifa }) {
  const Componente = vistasExpo[concepto];

  if (!Componente) {
    return <div>Vista no encontrada</div>;
  }

  return (
    <Componente
      onClose={onClose}
      valorActualExpo={tarifas[concepto]}
      actualizarTarifa={actualizarTarifa}
      concepto={concepto}
    />
  );
}

export default VistaDetalleExpo;
